const tabsContainer = document.querySelectorAll("[data-tabs-container]");

if (tabsContainer.length) {
    import("./modules/tabs.min.js")
        .then(
            tabs => tabs.initTabs(tabsContainer)
    );
}